import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { catchError, Observable, throwError } from 'rxjs';
import { TransactionModelInterface } from 'src/app/interface/transaction-model.interface';
import { OpenIdProfileMixin } from 'src/app/mixin/open-id-profile.mixin';
import { OpenIdProfile, OpenIdService } from 'src/app/service/open-id.service';

class BaseExtend {
    constructor(protected openIdService: OpenIdService) {}
}
const FinalExtended = OpenIdProfileMixin(BaseExtend);

export interface CommonDialogData {
    transactionModel?: TransactionModelInterface;
    dialogContext?: boolean;
    openIdProfile?: OpenIdProfile;
}

export class CommonElementsConfig {
    public amount = false;
    public comment = false;
    public referenceId = false;
    public receiverEmail = false;

    constructor(elements: string[] = []) {
        for (let e of elements) {
            if (e == 'amount') this.amount = true;
            if (e == 'comment') this.comment = true;
            if (e == 'referenceId') this.referenceId = true;
            if (e == 'receiverEmail') this.receiverEmail = true;
        }
    }
}

@Component({
    selector: 'app-common',
    templateUrl: './common.component.html',
    styleUrls: ['./common.component.css'],
})
export class CommonComponent extends FinalExtended implements OnInit {
    public formGroup = new FormGroup({
        amount: new FormControl(),
        comment: new FormControl(),
        referenceId: new FormControl(),
        receiverEmail: new FormControl(),
    });

    public elements: CommonElementsConfig = new CommonElementsConfig();

    public success: boolean = false;
    public message?: string;

    public submitLabel = 'Request';
    public headingLabel = 'Common';

    public processing = false;
    public dialogContext = false;

    public actionComplete = false;

    public transactionModel?: TransactionModelInterface;
    public tgtOpenIdProfile?: OpenIdProfile;

    constructor(
        protected httpClient: HttpClient,
        openIdService: OpenIdService,
        @Optional() public dialogRef: MatDialogRef<CommonComponent>,
        @Optional()
        @Inject(MAT_DIALOG_DATA)
        public dialogData?: CommonDialogData
    ) {
        super(openIdService);
    }

    ngOnInit(): void {
        if (this.dialogData) {
            if (this.dialogData.dialogContext) {
                this.dialogContext = this.dialogData.dialogContext;
            }

            if (this.dialogData.transactionModel) {
                this.transactionModel = this.dialogData.transactionModel;
            }

            if (this.dialogData.openIdProfile) {
                this.tgtOpenIdProfile = this.dialogData.openIdProfile;
            }
        }
    }

    public cancel() {
        this.dialogRef.close();
    }

    public submit() {
        console.log('Override in child');
    }

    protected sendPayload(url: string, payload: any) {
        this.processing = true;
        this.httpClient
            .post(url, payload)
            .pipe(
                catchError((e: any, caught: Observable<Object>) => {
                    this.message = e.error.message;
                    this.processing = false;
                    this.actionComplete = true;
                    return throwError(() => new Error(e));
                })
            )
            .subscribe((response: any) => {
                this.success = response.success;
                if (response.success && 'transaction' in response) {
                    let tx = response.transaction;
                    this.message = `Your request has been ${tx.result}.`;
                    if (tx.result != 'APPROVED') {
                        this.message = `${this.message} ${tx.comment}`;
                        this.success = false;
                    }
                } else {
                    this.message = response.message;
                }
                this.processing = false;
                this.actionComplete = true;
            });
    }

    public validate() {
        this.success = false;
        this.message = undefined;
        if (this.formGroup.valid) {
            this.submit();
        } else {
            this.message = 'All fields are required.';
        }
    }
}
